import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    action: {
      label: {
        id: 'properties.action',
        defaultMessage: 'Action',
        description: 'label of the action field',
      },
    },
    reference: {
      label: {
        id: 'properties.reference',
        defaultMessage: 'Reference',
        description: 'label of the reference field',
      },
    },
    datasetType: {
      label: {
        id: 'properties.datasetType',
        defaultMessage: 'Type of data',
        description: 'label of the dataset type field',
      },
    },
  },
  datasetTypes: {
    file: {
      label: {
        id: 'properties.file',
        defaultMessage: 'File (csv/excel)',
        description: 'label of the file dataset type',
      },
    },
    spreadsheet: {
      label: {
        id: 'properties.spreadsheet',
        defaultMessage: 'Spreadsheet',
        description: 'label of the spreadsheet dataset type',
      },
    },
  },
  actions: {
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'Cancel',
      description: 'Label of the cancel action',
    },
    run: {
      id: 'actions.run',
      defaultMessage: 'Run',
      description: 'Label of the run action',
    },
    runLater: {
      id: 'actions.runLater',
      defaultMessage: 'Run later',
      description: 'Label of the run later action',
    },
    next: {
      id: 'actions.next',
      defaultMessage: 'Next',
      description: 'Label of the next action',
    },
    previous: {
      id: 'actions.previous',
      defaultMessage: 'Previous',
      description: 'Label of the previous action',
    },
  },
  feedback: {
    batchStarted: {
      id: 'batchForm.feedback.batchStarted',
      defaultMessage: 'Batch started',
      description: 'Success message of the batch started action',
    },
    batchNotStarted: {
      id: 'batchForm.feedback.batchNotStarted',
      defaultMessage: 'Batch could not start',
      description: 'Error message of the batch started action',
    },
    batchSaved: {
      id: 'batchForm.feedback.batchSaved',
      defaultMessage: 'Batch saved',
      description: 'Success message of the batch saved action',
    },
    batchNotSaved: {
      id: 'batchForm.feedback.batchNotSaved',
      defaultMessage: 'Batch could not be saved',
      description: 'Error message of the batch saved action',
    },
  },
};

export default defineMessages(translations);
